import UploadCard from "./UploadCard";

export default UploadCard;
